// config.js
const config = {
    currentEvent: "LACNIC 43",
    pastEvent: "LACNIC 42", 
    REACT_APP_EVENT_SLUG:"LACNIC43",
    REACT_APP_PAST_EVENT_SLUG:"LACNIC 42",
    REACT_APP_API_URL_BASE: "https://apievt.lacnic.net/wp-json",
    REACT_APP_API_URL: "https://apievt.lacnic.net/wp-json/wp/v2",
    REACT_APP_API_URL_MENU: "https://apievt.lacnic.net/wp-json/menus/v1/menus",
    lacnogEvent: "LACNOG 2024",
    eventDate: "2024/10/07",
    // ID del evento actual
    currentEventID: 217, 
    currentEventID_en: 218, 
    currentEventID_pt_br: 219,
    // ID del evento pasada
    pastEventID: 204,
    pastEventID_en: 205,
    pastEventID_pt_br: 206,
    // Archivos de configuración Zona Horaria: HourRow.jsx, TimeZoneState.jsx
    eventTimeZone: 'America/Sao_Paulo',
    utcEventTimeZone: 'GMT-0300',
    currentEventCountry: 'Brasil',
    // URLs importantes
    registrationURL: 'https://eventos.lacnic.net/ev4/detail?id=lacnic43',
    // Menu
    useAppMenu: false, // Cambia a true cuando quieras usar el menú de la app
  };
  
export default config;
  